const { navigator: { userAgent } } = require('window');

const EventEmitter = require('events');

const _ = require('lodash');

import ko from 'rgs-knockout';
import kv from 'rgs-knockout-validation';
import vb from 'validation-builder';

const { JSableMixin } = require('jsable');
const { ValidatableMixin } = require('validatable');

import {
	LK_FEEDBACK_CATEGORY,
	LK_CHANGE_FIO_FEEDBACK_SUBCATEGORY,
	OSAGO_FEEDBACK_CATEGORY,
	OSAGO_CANT_FIND_TS_FEEDBACK_SUBCATEGORY,
	OSAGO_WANT_TO_MAKE_CHANGES_FEEDBACK_SUBCATEGORY,
	OSAGO_RSA_CHECK_DIDNT_PASSED_FEEDBACK_SUBCATEGORY,
	OSAGO_KBM_FEEDBACK_SUBCATEGORY,
	OSAGO_DIAGNOSTIC_CARD_FEEDBACK_SUBCATEGORY,
	OSAGO_CANT_LOAD_DATA_FEEDBACK_SUBCATEGORY,
	FLAT_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY,
	VZR_FEEDBACK_CATEGORY,
	VZR_CANT_GET_POLICY_FEEDBACK_SUBCATEGORY,
	MITE_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY,
	RF_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY,
} from 'known-feedback-categories';

import browserTypeDetector from 'browser-type-detector';
import { serverTime } from 'observable-server-time';

const ValidatableJSableEventEmitter = ValidatableMixin(JSableMixin(EventEmitter));

ko.extenders.prefillable = function (target) { // HACK
	target.isPrefilled = ko.observable(false);
};

export default class CalculatorFeedbackModel extends ValidatableJSableEventEmitter {
	constructor (options) {
		super();

		this._options = options;

		this._profile = options.profile;

		this.Category = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.required(),
			});

		this.CalculatorFeedbackCategoryID = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => Boolean(this.Category()), vb.required(),
				),
			});

		this._fullName = ko.pureComputed(() => {
			const [first, last, middle]
				= [ this.FirstName(), this.LastName(), this.MiddleName() ];
			return (last || '')
				+ ' '
				+ (first || '')
				+ (middle ? ' ' + middle : '');
		});

		this._newFullName = ko.pureComputed(() => {
			const [first, last, middle]
				= [ this.NewFirstName(), this.NewLastName(), this.NewMiddleName() ];
			return (last || '')
				+ ' '
				+ (first || '')
				+ (middle ? ' ' + middle : '');
		});

		const isPersonFullNameEntered = ko.pureComputed(() => {
			return Boolean(this.FirstName()) && Boolean(this.LastName());
		});

		const isPersonNewFullNameEntered = ko.pureComputed(() => {
			return Boolean(this.NewFirstName()) && Boolean(this.NewLastName());
		});

		this.FirstName = ko.observable()
			.extend({ prefillable: true })
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.required('введите имя'),
					vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
					vb.minLength(2),
					vb.maxLength(30),
					vb.if(
						() => isPersonFullNameEntered(),
						vb.extendedSameCharsetFullName(() => this._fullName()),
					),
				]),
			});

		this.MiddleName = ko.observable()
			.extend({ prefillable: true })
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
					vb.minLength(2),
					vb.maxLength(30),
					vb.if(
						() => isPersonFullNameEntered(),
						vb.extendedSameCharsetFullName(() => this._fullName()),
					),
				]),
			});
		
		this.LastName = ko.observable()
			.extend({ prefillable: true })
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.required('введите фамилию'),
					vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
					vb.minLength(2),
					vb.maxLength(30),
					vb.if(
						() => isPersonFullNameEntered(),
						vb.extendedSameCharsetFullName(() => this._fullName()),
					),
				]),
			});

		this.ProfileFirstName = ko.observable(this._profile.PhysicalPerson.FirstName())
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => this.isChangeFioMode(),
					vb.all([
						vb.required('введите имя'),
						vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
						vb.minLength(2),
						vb.maxLength(30),
					])
				),
			});

		this.ProfileMiddleName = ko.observable(this._profile.PhysicalPerson.MiddleName())
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => this.isChangeFioMode(),
					vb.all([
						vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
						vb.minLength(2),
						vb.maxLength(30),
					]),
				),
			});

		this.ProfileLastName = ko.observable(this._profile.PhysicalPerson.LastName())
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => this.isChangeFioMode(),
					vb.all([
						vb.required('введите фамилию'),
						vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
						vb.minLength(2),
						vb.maxLength(30),
					])
				),
			});

		this.ProfileBirthday = ko.observable(this._profile.PhysicalPerson.BirthDay())
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => this.isChangeFioMode(),
					vb.all([
						vb.required('введите дату рождения'),
						vb.momentIsValid(),
						vb.momentMinAge({
							age: 18,
							from: serverTime,
						}),
						vb.momentMaxAge({
							age: 130,
							from: serverTime,
						}),
					])
				),
			});

		this.NewFirstName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => this.isChangeFioMode(),
					vb.all([
						vb.required(),
						vb.lengthMin(2),
						vb.lengthMax(30),
						vb.consecutiveCharRepetitionLimit(3),
						vb.if(() => this._isForeignDocumentType(),
							vb.all([
								vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
							]),
							vb.all([
								vb.nameCyrillicWithSymbols(),
							])
						),
						vb.if(() => (isPersonNewFullNameEntered() && this._isForeignDocumentType()),
							vb.all([
								vb.extendedSameCharsetFullName(
									() => this._newFullName(), 'только латиница'
								),
							]),
							vb.all([
								vb.extendedSameCharsetFullName(
									() => this._newFullName(), 'только кириллица'
								),
							]),
						),
					]),
				),
			});

		this.NewMiddleName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => this.isChangeFioMode(),
					vb.all([
						vb.lengthMin(2),
						vb.lengthMax(30),
						vb.consecutiveCharRepetitionLimit(3),
						vb.if(() => this._isForeignDocumentType(),
							vb.all([
								vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
							]),
							vb.all([
								vb.nameCyrillicWithSymbols(),
							])),
						vb.if(() => (isPersonNewFullNameEntered() && this._isForeignDocumentType()),
							vb.all([
								vb.extendedSameCharsetFullName(
									() => this._newFullName(), 'только латиница',
								),
							]),
							vb.all([
								vb.extendedSameCharsetFullName(
									() => this._newFullName(), 'только кириллица'
								),
							]),
						),
					]),
				),
			});

		this.NewLastName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => this.isChangeFioMode(),
					vb.all([
						vb.required(),
						vb.lengthMin(2),
						vb.lengthMax(30),
						vb.consecutiveCharRepetitionLimit(3),
						vb.if(() => this._isForeignDocumentType(),
							vb.all([
								vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
							]),
							vb.all([
								vb.nameCyrillicWithSymbols(),
							])),
						vb.if(() => (isPersonNewFullNameEntered() && this._isForeignDocumentType()),
							vb.all([
								vb.extendedSameCharsetFullName(
									() => this._newFullName(), 'только латиница'
								),
							]),
							vb.all([
								vb.extendedSameCharsetFullName(
									() => this._newFullName(), 'только кириллица'
								),
							]),
						),
					]),
				),
			});

		this.NewBirthday = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => this.isChangeFioMode(),
					vb.all([
						vb.required('введите дату рождения'),
						vb.momentIsValid(),
						vb.momentMinAge({
							age: 18,
							from: serverTime,
						}),
						vb.momentMaxAge({
							age: 130,
							from: serverTime,
						}),
					])
				),
			});

		this.Phone = ko.observable(this._profile.PhysicalPerson.Phone())
			.extend({ prefillable: true })
			.extend({ toFromJS: true })
			.extend({
				validation: vb.required(),
			});
		
		this.Email = ko.observable()
			.extend({ prefillable: true })
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => !this.isMyRgsLoginRequired(),
					vb.all([
						vb.required(),
						vb.email(),
					])),
			});

		this.RegionID = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => !this.isChangeFioMode(), vb.required()
				),
			});

		this.identityDocumentType = ko.observable(
			this._profile.PhysicalPerson.IdentityDocument.Type()
		)
			.extend({ toFromJS: true });

		this._isForeignDocumentType = ko.pureComputed(
			() => this.identityDocumentType() === 'ForeignPassport'
		);

		this.Comment = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => !this.isChangeFioMode(), vb.required()),
					vb.maxLength(1000),
				]),
			});

		this.PreviousPolicyIsRgs = ko.observable(false)
			.extend({ toFromJS: true });

		this.PolicyNumber = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => {
						const id = this.Subcategory();
						return _.includes([
							OSAGO_WANT_TO_MAKE_CHANGES_FEEDBACK_SUBCATEGORY,
							OSAGO_RSA_CHECK_DIDNT_PASSED_FEEDBACK_SUBCATEGORY,
							OSAGO_KBM_FEEDBACK_SUBCATEGORY,
							OSAGO_CANT_LOAD_DATA_FEEDBACK_SUBCATEGORY,
							FLAT_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY,
							VZR_CANT_GET_POLICY_FEEDBACK_SUBCATEGORY,
							MITE_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY,
							RF_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY,
						], id);
					},
					vb.required(),
				),
			});

		const dicts = options.dictionaries;

		this.Browser = ko.observable(dicts.browserTypes[browserTypeDetector.getType()])
			.extend({ toJS: true });

		this.UserAgent = ko.constant(userAgent)
			.extend({ toJS: true });

		this.BoughtWhen = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.custom(
					(v) => {
						if (!v) {
							return true;
						}
						const re = /(\d{2})\.(\d{2})\.(\d{4})(?:\s+(\d{2}):(\d{2}))?/;
						const match = re.exec(v);
						if (!match) {
							return false;
						}
						_.range(1, 5).forEach(i => {
							match[i] = Number(match[i]);
						});
						const [, D, M, Y, h, m] = match;

						return D >= 1 && D <= 31
							&& M >= 1 && M <= 12
							&& Y >= 2000 && Y <= (new Date()).getFullYear()
							&& (isNaN(h) || h >= 0 && h <= 24)
							&& (isNaN(m) || m >= 0 && m <= 60);
					},
					'исправьте дату и время',
				),
			});

		this.IsTemporaryPassword = ko.observable()
			.extend({ fromJS: true });

		this.IsAuthenticated = ko.observable()
			.extend({ fromJS: true });

		this.CategoryOptions = ko.pureComputed(() => _.values(dicts.Categories));
		this.Subcategory = this.CalculatorFeedbackCategoryID;
		this.SubcategoryOptions = ko.pureComputed(() => {
			const cat = this.Category();
			return _.values(dicts.Categories[cat].Subcategories);
		});

		this.Policy = this.PolicyNumber;

		this.BrowserOptions = _.map(dicts.browserTypes, (v) => {
			return { name: v, value: v };
		});

		this.DateTime = this.BoughtWhen;

		this.Region = this.RegionID;
		this.RegionOptions = ko.pureComputed(() => {
			const sortPriorities = [77, 78, 50, 47].reverse();

			return _.values(dicts.Regions).sort((a, b) => {
				return (sortPriorities.indexOf(b.ID)
						- sortPriorities.indexOf(a.ID)) * 1000
					+ a.ID - b.ID;
			});
		});

		this.IsSmsNotificationRequired = ko.observable(false)
			.extend({ toFromJS: true });

		this.Files = ko.observable([])
			.extend({
				validation: vb.if(
					() => {
						const id = this.Subcategory();
						return _.includes([
							OSAGO_RSA_CHECK_DIDNT_PASSED_FEEDBACK_SUBCATEGORY,
							OSAGO_KBM_FEEDBACK_SUBCATEGORY,
							OSAGO_DIAGNOSTIC_CARD_FEEDBACK_SUBCATEGORY,
							LK_CHANGE_FIO_FEEDBACK_SUBCATEGORY,
						], id) || this.isVehicleModelNotFoundCategory();
					},
					vb.all([
						vb.custom(
							v => v && v.length,
							() => 'пожалуйста, приложите хотя бы один файл',
						),
						vb.custom(
							v => {
								const name = v && v.length && v[0].name;

								if (!v || !name) {
									return true;
								}
	
								return _.some(
									['pdf', 'jpg', 'jpeg', 'bmp', 'png', 'tif', 'gif'],
									ext => name.toLowerCase().endsWith('.' + ext)
								);
							},
							() => 'недопустимый формат файла',
						),
					])
				),
			})
			.extend({
				repr: (v) => {
					return v.length === 1 ? v[0].name : `Файлов: ${v.length}`;
				},
			});

		this.Busy = ko.observable(false);

		this.ErrorCode = ko.observable();

		this.Submitted = ko.observable(false);
		this.FeedbackID = ko.observable();
		this.PreviousFeedbackID = ko.observable();

		this.Files.rules.push({
			params: dicts.MaxAttachmentsSize,
			validator: (files, max) => {
				const size = _.sum(_.map(files, 'size'));
				return size < max;
			},
			message: (bytes) => {
				return 'размер файлов не должен превышать '
					+ (bytes / 1024 / 1024).toFixed(2).replace(/\.0+$/, '')
					+ ' МБ';
			},
		});

		//Вспомогательные флаги

		this.isTechnicalQuestion = ko.pureComputed(() => {
			const cat = this.Category();
			const subcat = this.Subcategory();
			const dictCat = dicts.Categories[cat];
			const dictSubcat = dictCat ? dictCat.Subcategories[subcat] : null;

			return dictSubcat ? dictSubcat.IsTechnicalQuestion : false;
		});
		
		this.isMyRgsLoginRequired = ko.pureComputed(() => {
			const cat = this.Category();
			return _.includes([
				OSAGO_FEEDBACK_CATEGORY,
				LK_FEEDBACK_CATEGORY,
			], cat);
		});
	
		this.isMyRgsLoggedIn = ko.pureComputed(() => {
			return this.IsAuthenticated();
				// Commented because origin of this logic is unknown
				//&& !this.IsTemporaryPassword();
		});
	
		this.isVehicleModelNotFoundCategory = ko.pureComputed(() => (
			this.Category() === OSAGO_FEEDBACK_CATEGORY
			&& this.Subcategory() === OSAGO_CANT_FIND_TS_FEEDBACK_SUBCATEGORY
		));
	
		this.isChangeFioMode = ko.pureComputed(() => (
			this.Category() === LK_FEEDBACK_CATEGORY
			&& this.Subcategory() === LK_CHANGE_FIO_FEEDBACK_SUBCATEGORY
		));

		this.isVzrCategory = ko.pureComputed(() => (
			this.Category() === VZR_FEEDBACK_CATEGORY
		));

		this.submitButtonDisabledReason = ko.pureComputed(() => {
			if (this.isMyRgsLoginRequired() && !this.isMyRgsLoggedIn()) {
				return 'MyRgsLoginRequired';
			}
			return null;
		});

		this.submitButtonDisabled = ko.pureComputed(() => {
			return Boolean(this.submitButtonDisabledReason());
		});

		this.NewFirstName.subscribe((val) => {
			if (this.isChangeFioMode()) {
				this.FirstName(val);
			}
		});

		this.NewLastName.subscribe((val) => {
			if (this.isChangeFioMode()) {
				this.LastName(val);
			}
		});

		this.NewMiddleName.subscribe((val) => {
			if (this.isChangeFioMode()) {
				this.MiddleName(val);
			}
		});
	}

	validationArray () {
		return _.filter(this, kv.utils.isValidatable);
	}

	_toJSOmit (v) {
		return super._toJSOmit(...arguments)
			|| (() => {
				if (!this.isTechnicalQuestion()) {
					return false;
				}
				return this.Category() !== OSAGO_FEEDBACK_CATEGORY
					&& (v === this.isTechnicalQuestion
					|| v === this.PolicyNumber
					|| v === this.Browser
					|| v === this.PreviousPolicyIsRgs
					|| v === this.UserAgent
					|| v === this.BoughtWhen);
			})();
	}
}
